/* Self-hosted how-to videos, streamed as HLS. Each entry names a folder in the
   video store holding master.m3u8 plus 1080p/720p/480p renditions, and a
   <file>.jpg poster beside it. The store is REACT_APP_VIDEO_BASE_URL (the S3
   location in production) and falls back to public/videos, which is gitignored
   and only used for local testing. */
export const VIDEO_BASE_URL = process.env.REACT_APP_VIDEO_BASE_URL || '/videos';

export const videos = [
  { file: 'step-1-adding-dna-to-plates', title: 'Step 1: Adding DNA to Plates' },
  { file: 'step-2-adding-s1-buffer', title: 'Step 2: Adding S1 Buffer' },
  { file: 'step-3-pcr-stage-1', title: 'Step 3: PCR Stage 1' },
  { file: 'step-4-adding-s2-buffer', title: 'Step 4: Adding S2 Buffer' },
  { file: 'step-5-pcr-stage-2', title: 'Step 5: PCR Stage 2' },
  { file: 'pcr-mat-cleaning-process', title: 'PCR Mat Cleaning Process' },
]
